export const vehicleConditions = ["new", "used", "imported"] as const;
export type VehicleConditions = (typeof vehicleConditions)[number];
import React from "react";
import buses_banner from "../assets/images/banners/buses_banner.jpg";
import lighttrucks_banner from "../assets/images/banners/lighttrucks_banner.jpg";
import heavytrucks_banner from "../assets/images/banners/heavytrucks_banner.jpg";
import trailers_banner from "../assets/images/banners/trailers_banner.jpg";
import machinery_banner from "../assets/images/banners/machinery_banner.jpg";
import handling_banner from "../assets/images/banners/handling_banner.jpg";
import { Bus, Forklift, LightTruck, Loaders, RefrigeratorSemiTrailer, TractorHead } from "../components/Icons";

export const vehicleTypes = [
  "bus",
  "light_trucks",
  "heavy_trucks",
  "trailers",
  "machinery",
  "handling_equipment",
] as const;
export type VehicleTypesT = (typeof vehicleTypes)[number];
export type VehicleNamesPluralT =
  | "buses"
  | "light_trucks"
  | "heavy_trucks"
  | "trailers"
  | "machinery"
  | "handling_equipment";

export type VehicleNames = {
  single: VehicleTypesT;
  plural: VehicleNamesPluralT;
  endpoint?: `${VehicleTypesT}/${VehicleConditions}`;
};

export type VehicleModule = {
  single: VehicleNames["single"];
  plural: VehicleNames["plural"];
  SliderBanner: string;
  Icon: React.ElementType;
};

export const vehicleModules: VehicleModule[] = [
  { single: "bus", plural: "buses", SliderBanner: buses_banner, Icon: Bus },
  { single: "light_trucks", plural: "light_trucks", SliderBanner: lighttrucks_banner, Icon: LightTruck },
  { single: "heavy_trucks", plural: "heavy_trucks", SliderBanner: heavytrucks_banner, Icon: TractorHead },
  { single: "trailers", plural: "trailers", SliderBanner: trailers_banner, Icon: RefrigeratorSemiTrailer },
  { single: "machinery", plural: "machinery", SliderBanner: machinery_banner, Icon: Loaders },
  { single: "handling_equipment", plural: "handling_equipment", SliderBanner: handling_banner, Icon: Forklift },
];

export const vehicleModulesMap = {
  bus: { single: "bus", plural: "buses" },
  light_trucks: { single: "light_trucks", plural: "light_trucks" },
  heavy_trucks: { single: "heavy_trucks", plural: "heavy_trucks" },
  trailers: { single: "trailers", plural: "trailers" },
  machinery: { single: "machinery", plural: "machinery" },
  handling_equipment: { single: "handling_equipment", plural: "handling_equipment" },
};

export type AttributesOption = {
  id: string;
  name: string;
  code: string;
  shape: "select" | "text" | "checkbox" | "multiselect" | "file";
  image?: string;
  required: boolean;
  is_filterable: boolean;
  values: {
    name: string;
    id: string;
    value: string;
    image?: string;
  }[];
  parentTruck?: string;
};

export type BannerPlaceT = Lowercase<
  | "home_page_slider"
  | "home_page_banner"
  | "single_Showroom_banner"
  | "single_Service_center_banner"
  | "new_cars"
  | "used_cars"
  | "imported_cars"
  | "new_buses"
  | "used_buses"
  | "imported_buses"
  | "new_motorcycles"
  | "used_motorcycles"
  | "imported_motorcycles"
  | "new_trucks"
  | "used_trucks"
  | "imported_trucks"
  | "used_Car"
  | "used_bus"
  | "used_motorcycle"
  | "used_truck"
  | "Imported_car"
  | "Imported_bus"
  | "Imported_motorcycle"
  | "Imported_truck"
  | "Mobile_slider"
  | "new_light_trucks"
  | "new_heavy_trucks"
  | "new_trailers"
  | "new_machinery"
  | "new_handling_equipment"
  | "used_light_trucks"
  | "imported_light_trucks"
  | "imported_heavy_trucks"
  | "imported_trailers"
  | "imported_machinery"
  | "used_heavy_trucks"
  | "imported_handling_equipment"
  | "used_trailers"
  | "used_machinery"
  | "used_handling_equipment"
>;
